import { isEmpty, startCase } from "lodash";
import moment from "moment/moment";

const MyBetsSingle = ({ res, active, handle, time }) => {
  const Render = ({ item, title, length }) => {
    let IdsItem = item?.map((obj) => {
      return obj?._id;
    });
    const allExistItem = IdsItem.every((id) => active.includes(id));
    return (
      <div className="s-list-group s-border-b-black-300 dark:s-border-black-900 s-border-b s-p-7px">
        <div className="s-list s-rounded s-flex s-gap-7px s-items-center s-justify-center s-delay-75 s-transition-all s-mb-7px">
          <div
            style={{ background: "#ffb80c", color: "black" }}
            className="s-text-button-normal s-count s-shrink-0 s-h-5 s-w-6 s-flex s-justify-center s-items-center s-text-10px s-bg-button-normal s-rounded s-font-bold"
          >
            {length}
          </div>
          <div className="s-flex-1 s-whitespace-pre-wrap s-leading-tight s-text-clip s-text-13px s-text-global-font-default-light dark:s-text-global-font-default-dark">
            <span className="s-text-17px s-font-bold s-mr-1 s-leading-120">
              {res?.eventName}
            </span>
            <div className="s-icon-triangle-black-300 dark:s-border-l-global-dark dark:s-opacity-30 s-inline-block s-align-baseline" />
            <span className="s-text-17px s-leading-120">{title} </span>
          </div>

          <div
            style={{ background: "#ffb80c", color: "black" }}
            onClick={() =>
              handle(
                item?.map((obj) => {
                  return obj?._id;
                }),
              )
            }
            className="s-flex s-flex-grow-0 s-flex-s-shrink-0 s-items-center s-justify-center s-w-25px s-h-25px s-text-11px s-rounded-3px s-bg-black-200 dark:s-bg-black-700 s-text-global-font-default-light dark:s-text-global-font-default-dark"
          >
            <div
              className={`s-icon-arrow-down s-transform s-rotate-0 s-transition-transform s-origin-center ${
                allExistItem ? "s-rotate-180" : ""
              } `}
            />
          </div>
        </div>
        {time && allExistItem && (
          <div className="s-pppp s-mybet-detail-content s-flex s-flex-col s-h-full s-rounded-4px">
            <div className="s-detail-list-area s-overflow-y-scroll s-rounded-3px s-flex-1">
              <div
                style={{ background: "#ffb80c" }}
                className="s-rounded-3px s-p-7px s-bg-black-200 dark:s-bg-black-700"
              >
                <div className="s-flex s-gap-2px s-flex-col s-wrapper s-overflow-y-scroll s-h-full">
                  {item?.map((item) => {
                    return (
                      <div className="list s-w-full s-rounded-3px">
                        <div className="list-s-content s-border s-border-black-300 dark:s-border-black-800 s-rounded-4px s-bg-white dark:s-bg-black-900">
                          <div className="s-row s-flex s-justify-between s-bg-black-100 dark:s-bg-black-800 s-text-13px s-min-h-40px s-items-center s-rounded-t-3px">
                            <div className="s-flex s-items-center">
                              <div
                                className={`${
                                  ["No", "lay"].includes(
                                    item?.betType || item?.type,
                                  )
                                    ? "bet-tag s-w-50px s-shrink-0 s-h-8 back s-relative s-flex s-justify-center s-items-center s-mr-2 s-text-15px s-font-bold s-text-center s-bg-back-200 dark:s-bg-back-300 s-rounded-3px s-text-black dark:s-text-black-900 s-bg-lay dark:s-bg-lay-300"
                                    : "bet-tag s-w-50px s-shrink-0 s-h-8 back s-relative s-flex s-justify-center s-items-center s-mr-2 s-text-15px s-font-bold s-text-center s-bg-back-200 dark:s-bg-back-300 s-rounded-3px s-text-black dark:s-text-black-900 s-bg-back-200 dark:s-bg-back-300"
                                } `}
                              >
                                {startCase(item?.betType || item?.type)}
                              </div>
                              <span className="s-min-h-28px s-flex s-items-center s-text-17px s-font-bold s-leading-120 s-break-all s-text-global-font-default-light dark:s-text-global-font-default-dark">
                                {["SportBook"].includes(title)
                                  ? `${item?.fancyName} | ${item?.runnerName}`
                                  : ["Fancy"].includes(title)
                                    ? item?.fancyName
                                    : item?.teamName || title}
                              </span>
                            </div>
                          </div>
                          <div className="s-row s-second s-flex s-border-t s-border-b s-border-black-300 dark:s-border-black-700 s-text-14px">
                            <div className="s-item odds s-border-r s-border-black-300 dark:s-border-black-700 s-p-2 s-flex-1 s-text-global-font-default-light dark:s-text-global-font-default-dark">
                              <div className="s-label s-text-12px">
                                {isEmpty(item?.fancyName)
                                  ? "Odds"
                                  : "Runs/Odds"}
                              </div>
                              <div className="s-content s-text-17px s-font-bold s-leading-120">
                                {title == "Fancy"
                                  ? `${item?.betRun} / ${item?.bhav}`
                                  : item?.bhav}
                              </div>
                            </div>
                            <div className="s-item stake s-border-r s-border-black-300 dark:s-border-black-700 s-p-2 s-flex-1 s-text-global-font-default-light dark:s-text-global-font-default-dark">
                              <div className="s-label s-text-12px">
                                Stake (USD)
                              </div>
                              <div className="s-content s-text-17px s-font-bold s-leading-120">
                                {item?.amount}
                              </div>
                            </div>
                            <div className="s-item s-profit s-p-2 s-flex-1 s-text-global-font-default-light dark:s-text-global-font-default-dark">
                              <div className="s-label s-text-12px">
                                {!isEmpty(item?.fancyName)
                                  ? "Libality (USD)"
                                  : "Profit (USD)"}{" "}
                              </div>
                              <div className="s-content s-text-17px s-font-bold s-leading-120">
                                {!isEmpty(item?.fancyName) ? (
                                  <span class="s-text-error-light dark:s-text-error-dark">
                                    ({item?.amount})
                                  </span>
                                ) : (
                                  <span>{item?.profitAmount}</span>
                                )}
                              </div>
                            </div>
                          </div>

                          <div className="s-row s-third">
                            <div className="s-flex s-justify-between s-text-12px">
                              <span>Ref: {item?.matchBetId}</span>
                              <span>
                                {moment(item?.timeInserted).format(
                                  "DD-MM-YYYY HH:MM",
                                )}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  };
  const allBets = [
    ...(res?.betList?.length
      ? res.betList?.map((obj) => {
          return { ...obj, showType: "Match Odds" };
        })
      : []),
    ...(res?.bookmakerList?.length
      ? res.bookmakerList?.map((obj) => {
          return { ...obj, showType: "Bookmaker" };
        })
      : []),
    ...(res?.sessionBetList?.length
      ? res.sessionBetList?.map((obj) => {
          return { ...obj, showType: obj?.fancyName };
        })
      : []),
    ...(res?.sportBookBetList?.length
      ? res.sportBookBetList?.map((obj) => {
          return { ...obj, showType: obj?.fancyName };
        })
      : []),
  ];
  let Ids = allBets?.map((obj) => {
    return obj?._id;
  });
  const allExist = Ids.every((id) => active.includes(id));

  return (
    <>
      {time && (
        <div>
          {res?.betList?.length > 0 && (
            <Render
              title={"Match Odds"}
              item={res?.betList}
              length={res?.betList?.length}
            />
          )}
          {res?.bookmakerList?.length > 0 && (
            <Render
              title={"Bookmaker"}
              item={res?.bookmakerList}
              length={res?.bookmakerList?.length}
            />
          )}
          {res?.sessionBetList?.length > 0 && (
            <Render
              title={"Fancy"}
              item={res?.sessionBetList}
              length={res?.sessionBetList?.length}
            />
          )}{" "}
          {res?.sportBookBetList?.length > 0 && (
            <Render
              title={"SportBook"}
              item={res?.sportBookBetList}
              length={res?.sportBookBetList?.length}
            />
          )}
        </div>
      )}
      {!time && (
        <div className="s-list-group s-border-b-black-300 dark:s-border-black-900 s-border-b s-p-7px">
          <div className="s-list s-rounded s-flex s-gap-7px s-items-center s-justify-center s-delay-75 s-transition-all s-mb-7px">
            <div
              style={{ background: "#ffb80c", color: "black" }}
              className="s-text-button-normal s-count s-shrink-0 s-h-5 s-w-6 s-flex s-justify-center s-items-center s-text-10px s-bg-button-normal s-rounded s-font-bold"
            >
              {res?.betList?.length +
                res?.bookmakerList?.length +
                res?.sessionBetList?.length +
                res?.sportBookBetList?.length}
            </div>
            <div className="s-flex-1 s-whitespace-pre-wrap s-leading-tight s-text-clip s-text-13px s-text-global-font-default-light dark:s-text-global-font-default-dark">
              <span className="s-text-17px s-font-bold s-mr-1 s-leading-120">
                {res?.eventName}
              </span>
            </div>

            <div
              style={{ background: "#ffb80c", color: "black" }}
              onClick={() => handle(Ids)}
              className="s-flex s-flex-grow-0 s-flex-s-shrink-0 s-items-center s-justify-center s-w-25px s-h-25px s-text-11px s-rounded-3px s-bg-black-200 dark:s-bg-black-700 s-text-global-font-default-light dark:s-text-global-font-default-dark"
            >
              <div
                className={`s-icon-arrow-down s-transform s-rotate-0 s-transition-transform s-origin-center ${
                  allExist ? "s-rotate-180" : ""
                } `}
              />
            </div>
          </div>
          {!time && (
            <div className="s-mybet-detail-content s-flex s-flex-col s-h-full s-bg-white dark:s-bg-black-800 s-rounded-t-4px">
              {allBets?.map((item, index) => {
                return (
                  <div className="s-detail-list-area s-overflow-y-scroll s-rounded-3px dark:s-bg-black-800 s-flex-1 s-mt-2px first:s-mt-0">
                    <div
                      style={{ background: "#ffb80c", color: "black" }}
                      className="s-rounded-3px s-bg-black-200 dark:s-bg-black-700 s-p-7px s-mt-2px first:s-mt-0"
                    >
                      <div className="s-wrapper s-overflow-y-scroll s-h-full">
                        <div className="s-list s-rounded">
                          <div className="s-flex s-justify-between s-items-center s-delay-100">
                            <p
                              style={{ color: "black" }}
                              className="s-text-17px s-font-bold s-leading-120 s-text-global-font-default-light dark:s-text-global-font-default-dark"
                            >
                              {item?.showType}
                            </p>
                            <div
                              onClick={() => handle(item?._id)}
                              className="s-flex s-items-center s-justify-center s-w-21px s-h-21px s-bg-white dark:s-bg-black-800 s-rounded-3px"
                            >
                              <i
                                style={{ color: "white" }}
                                className={`s-icon-arrow-down s-text-11px s-text-global-font-on-light s-transform s-transition-transform s-origin-center ${
                                  active.includes(item?._id)
                                    ? "s-rotate-180"
                                    : ""
                                } `}
                              />
                            </div>
                          </div>

                          {active.includes(item?._id) && (
                            <div className="s-pt-7px">
                              <div className>
                                <div className="list-s-content s-border s-border-black-300 s-bg-white dark:s-border-black-700 dark:s-bg-black-900 s-rounded-4px">
                                  <div className="s-row s-flex s-justify-between s-min-h-40px s-items-center s-rounded-t-4px">
                                    <div className="s-flex s-items-center">
                                      <div
                                        className={`${
                                          ["No", "lay"].includes(
                                            item?.betType || item?.type,
                                          )
                                            ? "bet-tag s-w-50px s-shrink-0 s-h-8 back s-relative s-flex s-justify-center s-items-center s-mr-2 s-text-15px s-font-bold s-text-center s-bg-back-200 dark:s-bg-back-300 s-rounded-3px s-text-black dark:s-text-black-900 s-bg-lay dark:s-bg-lay-300"
                                            : "bet-tag s-w-50px s-shrink-0 s-h-8 back s-relative s-flex s-justify-center s-items-center s-mr-2 s-text-15px s-font-bold s-text-center s-bg-back-200 dark:s-bg-back-300 s-rounded-3px s-text-black dark:s-text-black-900 s-bg-back-200 dark:s-bg-back-300"
                                        } `}
                                      >
                                        {startCase(item?.betType || item?.type)}
                                      </div>
                                      <span className="s-flex s-items-center s-text-17px s-font-bold s-min-h-28px s-leading-tight s-break-all s-text-global-font-default-light dark:s-text-global-font-default-dark">
                                        {item?.teamName || item?.fancyName}
                                      </span>
                                    </div>
                                  </div>
                                  <div className="s-row s-second s-flex s-border-t s-border-b s-border-black-300 dark:s-border-black-700 s-text-14px">
                                    <div className="s-item odds s-border-r s-border-black-300 dark:s-border-black-700 s-p-2 s-flex-1 s-text-global-font-default-light dark:s-text-global-font-default-dark">
                                      <div className="s-label s-text-12px">
                                        {isEmpty(item?.fancyName)
                                          ? "Odds"
                                          : "Runs/Odds"}
                                      </div>
                                      <div className="s-content s-text-17px s-font-bold s-leading-120">
                                        {item?.bhav}
                                      </div>
                                    </div>
                                    <div className="s-item stake s-border-r s-border-black-300 dark:s-border-black-700 s-p-2 s-flex-1 s-text-global-font-default-light dark:s-text-global-font-default-dark">
                                      <div className="s-label s-text-12px">
                                        Stake (USD)
                                      </div>
                                      <div className="s-content s-text-17px s-font-bold s-leading-120">
                                        {item?.amount}
                                      </div>
                                    </div>
                                    <div className="s-item s-profit s-p-2 s-flex-1 s-text-global-font-default-light dark:s-text-global-font-default-dark">
                                      <div className="s-label s-text-12px">
                                        {!isEmpty(item?.fancyName)
                                          ? "Libality (USD)"
                                          : "Profit (USD)"}{" "}
                                      </div>
                                      <div className="s-content s-text-17px s-font-bold s-leading-120">
                                        {!isEmpty(item?.fancyName) ? (
                                          <span class="s-text-error-light dark:s-text-error-dark">
                                            ({item?.amount})
                                          </span>
                                        ) : (
                                          <span>{item?.profitAmount}</span>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                  <div className="s-row s-third">
                                    <div className="s-flex s-justify-between s-text-12px">
                                      <span>Ref: {item?.matchBetId}</span>
                                      <span>
                                        {moment(item?.timeInserted).format(
                                          "DD-MM-YYYY HH:MM",
                                        )}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default MyBetsSingle;
